import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { C, card, label, btn, input, GLYPH, ELEMENT_COLOR, LOT_COLORS, LOTS } from "../lib/theme";
import ChartWheel from "../lib/ChartWheel";
import { loggedIn } from "../lib/api";

const SIGNS = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio",
  "Sagittarius","Capricorn","Aquarius","Pisces"];

export default function Calculator() {
  const [f, setF] = useState({ date: "", time: "12:00", lat: "", lon: "" });
  useEffect(() => {
    const prev = document.title;
    document.title =
      "Free Zodiacal Releasing Calculator — All 8 Hermetic Lots | Astrology Calendar";
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = "https://spiritclock.app/calculator";
    document.head.appendChild(link);
    return () => { document.title = prev; link.remove(); };
  }, []);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const [selLot, setSelLot] = useState("Spirit");
  const [err, setErr] = useState("");

  const compute = async () => {
    setBusy(true); setErr("");
    try {
      const r = await fetch(`${import.meta.env.VITE_API_BASE || ""}/v1/public/zr-calculator`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ birth_local: `${f.date}T${f.time}`,
          lat: Number(f.lat), lon: Number(f.lon) }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.statusText);
      setRes(d);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const positionsForWheel = res
    ? Object.fromEntries(Object.entries(res.positions).map(([b, v]) =>
        [b, SIGNS.indexOf(v.sign) * 30 + v.degree]))
    : null;
  const lotsForWheel = res
    ? Object.fromEntries(Object.entries(res.lots).map(([k, v]) => [k, { lon: v.lot_lon }]))
    : null;
  const lot = res?.lots[selLot];

  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text,
      fontFamily: C.font, padding: "30px 16px 60px" }}>
      <div style={{ maxWidth: 880, margin: "0 auto" }}>
        <h1 style={{ fontFamily: C.displayFont, fontSize: 32, fontWeight: 500, margin: 0 }}>
          Zodiacal Releasing Calculator</h1>
        <div style={{ fontSize: 13, color: C.dim, margin: "4px 0 6px" }}>
          All <b style={{ color: C.text }}>eight Hermetic lots</b> — Spirit, Fortune, Eros,
          Necessity, Courage, Victory, Nemesis, and Death — with time lords, peaks,
          Loosing of the Bond, your whole-sign wheel, and this year's annual profection.
        </div>
        <div style={{ fontSize: 11.5, color: C.faint, marginBottom: 16 }}>
          Free, no signup. Computed in memory — nothing you enter here is stored.
          {" "}{!loggedIn() && <Link to="/" style={{ color: C.brass }}>
            Sign in to log life events against your periods →</Link>}
        </div>

        <div style={{ ...card, marginBottom: 14 }}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })}
              style={input} aria-label="Birth date" />
            <input type="time" value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })}
              style={input} aria-label="Birth time" />
            <input placeholder="Latitude (e.g. 42.65)" value={f.lat}
              onChange={(e) => setF({ ...f, lat: e.target.value })} style={{ ...input, width: 150 }} />
            <input placeholder="Longitude (e.g. -73.76)" value={f.lon}
              onChange={(e) => setF({ ...f, lon: e.target.value })} style={{ ...input, width: 150 }} />
            <button style={btn()} disabled={busy || !f.date || f.lat === "" || f.lon === ""}
              onClick={compute}>{busy ? "Computing…" : "Compute"}</button>
          </div>
          <div style={{ fontSize: 10.5, color: C.faint, marginTop: 6 }}>
            Timezone and daylight saving are resolved automatically from the coordinates —
            the most common source of wrong Ascendants elsewhere.
          </div>
          {err && <div style={{ color: C.rose, fontSize: 12, marginTop: 8 }}>{err}</div>}
        </div>

        {res && (<>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start",
            marginBottom: 14 }}>
            <div style={{ ...card, textAlign: "center" }}>
              <ChartWheel positions={positionsForWheel} lots={lotsForWheel}
                asc={res.asc_sign} ascLon={res.asc_lon} size={320} />
              <div style={{ fontSize: 11.5, color: C.dim, marginTop: 2 }}>
                {res.asc_sign} rising · {res.sect} chart · {res.tz}</div>
            </div>
            <div style={{ flexGrow: 1, minWidth: 280 }}>
              <div style={{ ...card, marginBottom: 12 }}>
                <div style={label}>ANNUAL PROFECTION (TODAY)</div>
                <div style={{ fontSize: 13 }}>
                  Age {res.profection.age} · house {res.profection.house} ·{" "}
                  <span style={{ color: ELEMENT_COLOR(res.profection.sign) }}>
                    {GLYPH[res.profection.sign]}</span> {res.profection.sign} ·
                  profection lord <b style={{ color: C.brass }}>{res.profection.profection_lord}</b>
                </div>
              </div>
              <div style={card}>
                <div style={label}>TODAY'S RELEASING — ALL EIGHT LOTS</div>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <tbody>
                    {LOTS.map((L) => {
                      const t = res.lots[L].today;
                      return (
                        <tr key={L} style={{ borderTop: `1px solid ${C.line}`, cursor: "pointer",
                          background: selLot === L ? C.surface2 : "transparent" }}
                          onClick={() => setSelLot(L)}>
                          <td style={{ padding: "5px 6px", color: LOT_COLORS[L], fontWeight: 600 }}>{L}</td>
                          {["L1","L2","L3","L4"].map((lv) => (
                            <td key={lv} style={{ padding: "5px 4px" }}>
                              {t[lv] ? <>
                                <span style={{ color: ELEMENT_COLOR(t[lv].sign) }}>{GLYPH[t[lv].sign]}</span>
                                <span style={{ color: C.dim, fontSize: 10.5 }}> {t[lv].lord}</span>
                                {t[lv].peak && <span style={{ color: C.brass }}> ·</span>}
                                {t[lv].lb && <span style={{ color: C.rose }}> ×</span>}
                              </> : "—"}
                            </td>))}
                        </tr>);
                    })}
                  </tbody>
                </table>
                <div style={{ fontSize: 10, color: C.faint, marginTop: 4 }}>
                  · = peak (angular from Fortune) · × = Loosing of the Bond · click a lot
                  for its timeline
                </div>
              </div>
            </div>
          </div>

          <div style={{ ...card, marginBottom: 14 }}>
            <div style={label}>
              LOT OF {selLot.toUpperCase()} — RELEASED FROM {lot.release_sign.toUpperCase()}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <div>
                <div style={{ fontSize: 10.5, color: C.faint, marginBottom: 4 }}>L1 CHAPTERS (LIFETIME)</div>
                {lot.l1_periods.map((p, i) => (
                  <div key={i} style={{ fontSize: 12, padding: "3px 0",
                    borderTop: `1px solid ${C.line}` }}>
                    <span style={{ color: ELEMENT_COLOR(p.sign) }}>{GLYPH[p.sign]}</span>{" "}
                    {p.sign} <span style={{ color: C.dim }}>({p.lord})</span>
                    <span style={{ float: "right", fontFamily: "ui-monospace,monospace",
                      fontSize: 10.5, color: C.faint }}>{p.start} → {p.end}</span>
                    {p.peak && <span style={{ color: C.brass, fontSize: 10 }}> PEAK</span>}
                    {p.lb && <span style={{ color: C.rose, fontSize: 10 }}> LB</span>}
                  </div>))}
              </div>
              <div>
                <div style={{ fontSize: 10.5, color: C.faint, marginBottom: 4 }}>
                  L2 WITHIN THE CURRENT L1</div>
                {lot.l2_in_current_l1.map((p, i) => (
                  <div key={i} style={{ fontSize: 12, padding: "3px 0",
                    borderTop: `1px solid ${C.line}` }}>
                    <span style={{ color: ELEMENT_COLOR(p.sign) }}>{GLYPH[p.sign]}</span>{" "}
                    {p.sign} <span style={{ color: C.dim }}>({p.lord})</span>
                    <span style={{ float: "right", fontFamily: "ui-monospace,monospace",
                      fontSize: 10.5, color: C.faint }}>{p.start} → {p.end}</span>
                    {p.peak && <span style={{ color: C.brass, fontSize: 10 }}> PEAK</span>}
                    {p.lb && <span style={{ color: C.rose, fontSize: 10 }}> LB</span>}
                  </div>))}
              </div>
            </div>
          </div>
        </>)}

        <div style={{ ...card, borderColor: C.brass }}>
          <div style={label}>HOW WE VALIDATE</div>
          <div style={{ fontSize: 12.5, lineHeight: 1.7, color: C.dim }}>
            {res ? <>
              <b style={{ color: C.text }}>{res.validation.zr_reference}.</b>{" "}
              {res.validation.js_python_parity}. {res.validation.ephemeris}. Every result
              carries an engine version (<span style={{ fontFamily: "ui-monospace,monospace",
              fontSize: 11 }}>{res.validation.engine_version}</span>).
            </> : <>
              <b style={{ color: C.text }}>175/175 periods identical to the public reference
              implementation.</b> JS and Python engines byte-identical across 2,203 checks.
              Ingresses match published ephemerides to the minute. Every result carries an
              engine version.
            </>}
            {" "}Check us against your own ephemeris — that's what this page is for.
          </div>
        </div>

        <Explainer />
      </div>
    </div>
  );
}

const FAQ = [
  ["What do I need to use this calculator?",
   "Your birth date, birth time, and birthplace coordinates. Birth time matters a great " +
   "deal: Zodiacal Releasing is counted from the Lots, and the Lots are calculated from " +
   "the Ascendant, which changes sign roughly every two hours."],
  ["What if I don't know my birth time?",
   "Zodiacal Releasing genuinely needs it — a guessed time can shift the Ascendant, move " +
   "every Lot, and change your whole timeline. Birth certificates, hospital records, and " +
   "family baby books are the usual sources. A noon guess is better than nothing for " +
   "planet signs, but treat any ZR periods from a guessed time as provisional."],
  ["Which Lot should I read first?",
   "Traditionally, releasing from the Lot of Spirit describes your career and deliberate " +
   "actions, and releasing from the Lot of Fortune describes body, health, and " +
   "circumstance. Eros (love and desire) is the next most-read. This calculator computes " +
   "all eight Hermetic Lots so you can compare them."],
  ["What is a peak period?",
   "A period whose sign is angular (1st, 4th, 7th, or 10th) from the Lot of Fortune — " +
   "traditionally the chapters when your efforts are most visible and eventful. They are " +
   "marked with a dot in the results."],
  ["What is Loosing of the Bond?",
   "When the sequence of sub-periods returns to where it started, it leaps to the " +
   "opposite sign instead of repeating — a circuit-breaker moment that Hellenistic " +
   "astrologers read as a decisive change of direction. Marked with an × in the results."],
  ["What house system does this use?",
   "Whole-sign houses, as the Hellenistic sources themselves used: the rising sign is the " +
   "1st house, the next sign the 2nd, and so on."],
  ["How are the calculations verified?",
   "The period engine matches the public reference implementation on 175 of 175 test " +
   "periods across four birth charts, planetary positions come from the MIT-licensed " +
   "astronomy-engine, and ingresses match published ephemerides to the minute. Every " +
   "result carries an engine version so it can be audited."],
  ["Is this free? Do you store my birth data?",
   "Free, no signup, and this page stores nothing — your birth data is used in memory to " +
   "compute the result and discarded. A free account adds the calendar view, transits, " +
   "and event journaling on top of the same engine."],
];

function Explainer() {
  return (
    <div style={{ marginTop: 26 }}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage",
        mainEntity: FAQ.map(([q, a]) => ({ "@type": "Question", name: q,
          acceptedAnswer: { "@type": "Answer", text: a } })),
      }) }} />
      <h2 style={{ fontFamily: C.displayFont, fontSize: 22, fontWeight: 500,
        margin: "0 0 6px" }}>What is Zodiacal Releasing?</h2>
      <p style={pStyle}>
        Zodiacal Releasing is a Hellenistic timing technique recorded by the 2nd-century
        astrologer Vettius Valens. Instead of asking what your chart says about you, it
        asks <i>when</i>: it divides a life into chapters and sub-chapters, like nested
        acts of a play, each ruled by the planet governing its sign. The technique
        &ldquo;releases&rdquo; from one of the chart&rsquo;s calculated Lots — most famously
        the <b>Lot of Spirit</b> (career and deliberate action) and the <b>Lot of
        Fortune</b> (body, health, and circumstance) — and steps through the zodiac from
        there, each sign granted a set number of years. The result is a timeline: level-1
        chapters spanning years to decades, subdivided into level-2, level-3, and level-4
        periods down to days.
      </p>
      <h2 style={h2Style}>The eight Hermetic Lots</h2>
      <p style={pStyle}>
        The Lots are calculated points — arithmetic combinations of the Sun, Moon,
        Ascendant, and planets, with formulas that flip between day and night charts.
        Beyond Spirit and Fortune, the Hermetic tradition names six more: <b>Eros</b>
        {" "}(love and desire), <b>Necessity</b> (constraint and what must be
        faced), <b>Courage</b> (boldness and conflict), <b>Victory</b> (success and
        support), <b>Nemesis</b> (undoing and blind spots), and <b>Death</b> (endings
        and inheritance — read symbolically, not literally). Most calculators offer one
        or two; this one releases from all eight, so you can watch, say, an Eros chapter
        turn while a Spirit chapter holds steady.
      </p>
      <h2 style={h2Style}>Peaks and the Loosing of the Bond</h2>
      <p style={pStyle}>
        Two structural moments matter most in reading a timeline. <b>Peak periods</b> are
        chapters whose sign sits angular to the Lot of Fortune — traditionally the most
        visible, eventful stretches, when what you do lands in public view. The
        {" "}<b>Loosing of the Bond</b> is stranger: when the subdividing sequence would
        return to its starting sign, it jumps to the opposite sign instead — a built-in
        plot twist that Valens treated as a decisive break, often felt as a change of
        chapter mid-story. The calculator marks both on every level of the timeline.
      </p>
      <h2 style={h2Style}>Frequently asked questions</h2>
      {FAQ.map(([q, a]) => (
        <div key={q} style={{ marginBottom: 10 }}>
          <h3 style={{ fontSize: 13.5, fontWeight: 600, margin: "0 0 3px", color: C.text }}>{q}</h3>
          <p style={{ ...pStyle, margin: 0 }}>{a}</p>
        </div>
      ))}
    </div>
  );
}

const pStyle = { fontSize: 13, color: C.dim, lineHeight: 1.7, margin: "0 0 14px" };
const h2Style = { fontFamily: C.displayFont, fontSize: 22, fontWeight: 500, margin: "18px 0 6px" };
